import React from 'react';

import i18n from 'util/i18n';
import { PSYCHOLOGICAL } from 'config/formSections/psychological';

import SectionIntro from 'components/Section/shared/SectionIntro';
import { isPVQForm } from 'helpers/form';
import { PVQ_A_B_D } from 'constants/formTypes';

const Intro = function (props) {
  const sectionPrefix = (props?.formType === PVQ_A_B_D) ? 'Part D:' : 'Section 28:';

  const isPvq = isPVQForm(props.formType);
  return isPvq ? (
    <SectionIntro
      title={`${sectionPrefix} ${i18n.t('psychological.pvq.intro.title')}`}
      fieldTitle=""
      body={(
        <span>
          {i18n.m('psychological.pvq.intro.para1')}
          {i18n.m('psychological.pvq.intro.para2')}
          {i18n.m('psychological.pvq.intro.para3')}
        </span>
      )}
      sectionKey={PSYCHOLOGICAL.key}
    />
  ) : (
    <SectionIntro
      title={i18n.t('psychological.intro.title')}
      fieldTitle={i18n.t('psychological.heading.intro')}
      body={(
        <span>
          {i18n.m('psychological.intro.para1')}
          {i18n.m('psychological.intro.para2')}
          {i18n.m('psychological.intro.para3')}
          {i18n.m('psychological.intro.para4')}
        </span>
)}
      sectionKey={PSYCHOLOGICAL.key}
    />
  );
};

export default Intro;
